import { render, staticRenderFns } from "./CustomerServiceStatistics.vue?vue&type=template&id=2cf31949&scoped=true&"
import script from "./CustomerServiceStatistics.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf31949",
  null
  
)

export default component.exports